import React from "react";
import { Card, Flex, Link, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { EntityBankAccountType } from "../types";
import { entityBankAccountCard, entityBankAccountCardIcon } from "./styles_vanilla.css";

export interface EntityBankAccountCardProps {
  bankAccount: EntityBankAccountType | null;
  bankAccountUrl?: string | null;
}

export const EntityBankAccountCard: React.FC<EntityBankAccountCardProps> = ({
  bankAccount,
  bankAccountUrl,
}) => {
  if (!bankAccount) {
    return null;
  }

  const accountLabel = bankAccount.bankName
    ? `${bankAccount.bankName} account ending in -${bankAccount.bankInfoRedacted}`
    : `Account ending in -${bankAccount.bankInfoRedacted}`;

  return (
    <Card className={entityBankAccountCard}>
      <Flex alignItems="flex-start" flexDirection="row">
        <Flex flexDirection="row" alignItems="flex-start" gap={20}>
          <Icon type="wallet" size="x-large" className={entityBankAccountCardIcon} />
          <Flex flexDirection="column" gap="xs">
            {bankAccountUrl ? (
              <Link
                href={bankAccountUrl}
                align="left"
                icon="external-link"
                iconPosition="right"
                shouldOpenInNewTab
              >
                {accountLabel}
              </Link>
            ) : (
              <Text variant="strong-md">{accountLabel}</Text>
            )}
            {bankAccount.ownerName && (
              <Text variant="secondary-md">
                Account holder <strong>{bankAccount.ownerName}</strong>{" "}
              </Text>
            )}
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
};
